// @ts-nocheck

import dash_api from '../support/dash_api';
import type {
  AppStoreConnectCredentialsRequestPayload,
  IncomingAppStoreConnectCredentials,
  IncomingAppStoreIntegrationData,
  SavedAppStoreConnectCredentials,
  VerificationStatus,
} from '../types/appStoreConnectTypes';
const APP_STORE_CONNECT_PATH = '/v1/app-store-connect';
export function processIncomingAppStoreConnectCredentials(
  credentials: IncomingAppStoreConnectCredentials
): SavedAppStoreConnectCredentials | null | undefined {
  if (!credentials.app_store_connect_issuer_id || !credentials.app_store_connect_key_id) {
    return null;
  }

  return {
    issuerId: credentials.app_store_connect_issuer_id,
    keyId: credentials.app_store_connect_key_id,
  };
}
export function processIncomingAppStoreIntegrationData(data: {
  status: VerificationStatus;
  iosAppStoreVerification?: IncomingAppStoreIntegrationData;
}): {
  verificationStatus: VerificationStatus;
  iosAppStoreId?: string;
  iosAppStoreIdVerified?: boolean;
} {
  return {
    verificationStatus: data.status,
    iosAppStoreId: data.iosAppStoreVerification && data.iosAppStoreVerification.ios_app_store_id,
    iosAppStoreIdVerified: data.iosAppStoreVerification && data.iosAppStoreVerification.ios_app_store_id_verified,
  };
}
export function saveAppStoreConnectCredentials(payload: AppStoreConnectCredentialsRequestPayload) {
  const { privateKeyFile, issuerId, keyId } = payload;
  const formData = new FormData();
  formData.append(privateKeyFile.name, privateKeyFile);
  formData.append('keyId', JSON.stringify(keyId));
  formData.append('issuerId', JSON.stringify(issuerId));
  return dash_api
    .post(`${APP_STORE_CONNECT_PATH}/credentials`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then(({ data }) => {
      return processIncomingAppStoreConnectCredentials(data);
    });
}
export function getAppStoreConnectCredentials() {
  return dash_api.get(`${APP_STORE_CONNECT_PATH}/credentials`).then(({ data }) => {
    return processIncomingAppStoreConnectCredentials(data);
  });
}
export function deleteAppStoreConnectCredentials() {
  return dash_api.delete(`${APP_STORE_CONNECT_PATH}/credentials`).then(({ data }) => {
    return processIncomingAppStoreConnectCredentials(data);
  });
}
export function getAppVerificationStatus() {
  return dash_api.get(`${APP_STORE_CONNECT_PATH}/verification-status`).then(({ data }) => {
    return processIncomingAppStoreIntegrationData(data);
  });
}
export function verifyApp() {
  return dash_api.post(`${APP_STORE_CONNECT_PATH}/verify`).then(({ data }) => {
    return processIncomingAppStoreIntegrationData(data);
  });
}
export function revokeAppVerification() {
  return dash_api.delete(`${APP_STORE_CONNECT_PATH}/verification`).then(({ data }) => {
    return processIncomingAppStoreIntegrationData(data);
  });
}
